import DropDownEditor from "./DropDown";
import NumberEditor from "./NumberEditor";
import TextEditor from "./TextEditor";
import DateEditor from './DateEditor';
import FileEditor from "./FileEditor";
import TextArea from "./Textarea";


function Editor({
    type = 1,
    ...props
}) {

    switch (type) {
        case 1:
            return <TextEditor {...props}></TextEditor>
        case 2:
            return <NumberEditor {...props}></NumberEditor>
        case 3:
            return <DropDownEditor {...props}></DropDownEditor>
        case 4:
            return <DateEditor {...props}></DateEditor>
        case 5:
            return <FileEditor {...props}></FileEditor>
        case 6:
            return <TextArea {...props} />
        default:
            return <TextEditor {...props}></TextEditor>
    }

}

export default Editor;